<div class="container-fluid p-3 p-md-3 p-lg-4 container_global">
  <div
    class="d-flex justify-content-center align-items-center position-relative mb-4"
    >
    <div class="customTitlePage">
      <span>Cerca Dispositivo</span>
    </div>
  </div>

  <div class="col-12 text-center mt-2 mb-4">
    <span style="font-size: small; color: gray; font-style: italic">
      Ricerca dispositivo tramite Codice Seriale
    </span>
  </div>

  <div class="row justify-content-center mx-1">
    <div class="col-12 col-lg-10 col-xxl-8 cardElement">
      <div class="row justify-content-center">
        <!-- Primo campo -->
        <div class="col-12 col-md-10 col-lg-8 mt-4 text-center mb-2">
          <label class="fw-bold form-label">Ricerca</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Inserisci Codice Seriale"
              [(ngModel)]="searchQuery"
              />
            <button class="btn btn-outline-dark" (click)="searchSN()">
              Cerca
            </button>
          </div>
          @if (error) {
            <div>
              <span class="text-danger">
                Il codice seriale deve essere lungo almeno 5 caratteri
              </span>
            </div>
          }

        </div>
        <div class="col-12 col-md-10 col-lg-8 text-center mt-2 mb-3">
          <button class="btn btn-outline-danger" (click)="reset()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Paginated Results Display -->
  @if (paginatedData.length > 0) {
    <div
      class="row justify-content-center mx-1 mt-4"
      >
      <div class="col-12">
        <!-- Pagination Info -->
        <div class="row justify-content-center mt-2 p-3" style="border: 1px solid lightgray; background-color: white;">
          <div class="d-none d-md-inline col-4 text-start">
            <span style="font-size: small;">Risultati totali: {{totalResults}}</span>
          </div>
          <div class="d-none d-md-inline col-4 text-center">
            <span style="font-size: small;">Elementi per pagina: {{itemsPerPage}}</span>
          </div>
          <div class="col-6 d-sm-none text-start">
            <span style="font-size: small;">Ordinati per data</span>
          </div>
          <div class="col-6 col-sm-12 col-md-4 text-end">
            <span>
              <button [disabled]="currentPage == 1" class="btn btn-link me-2 p-0" (click)="prevPage()">
                <i class="bi bi-caret-left"></i>
              </button>
              <span style="font-size: small;">Pagina {{currentPage}} di {{totalPages}}</span>
              <button [disabled]="currentPage == totalPages" class="btn btn-link ms-2 p-0" (click)="nextPage()">
                <i class="bi bi-caret-right"></i>
              </button>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-3 mt-3">
            <h5 class="text-center">Risultati della ricerca</h5>
          </div>
          <!-- Data Cards -->
          @for (item of paginatedData; track item) {
            <div class="col-12 mb-3">
              <app-sn-card-search [item]="item"></app-sn-card-search>
            </div>
          }
        </div>
      </div>
    </div>
  }

  <!-- No Results Message -->
  @if (paginatedData.length === 0 && searchMade) {
    <div
      class="row justify-content-center mx-1 mt-4"
      >
      <div class="col-12 col-lg-10 col-xxl-8">
        <div class="alert alert-info text-center">
          <i class="bi bi-info-circle me-2"></i>
          Nessun risultato trovato. Prova a cercare con un codice seriale diverso.
        </div>
      </div>
    </div>
  }
</div>
